import { cn } from '@eliadmin/core/src/utils/style-utils';

export const Heading = ({
  title,
  className,
  size = 'base',
  as: Tag = 'h2',
}: {
  title: string;
  className?: { container?: string; title?: string };
  size?: 'sm' | 'base';
  as?: 'h1' | 'h2' | 'p';
}) => {
  return (
    <div className={cn(className?.container)}>
      <Tag
        data-ea-visual-tag={Tag === 'h2' ? undefined : 'h2'}
        className={cn(
          'font-bold text-foreground ',
          className?.title,
          size === 'sm' && 'text-xl lg:text-2xl',
          size === 'base' &&
            'text-3xl leading-snug sm:text-4xl sm:leading-snug lg:text-5xl lg:leading-tight',
        )}
      >
        {title}
      </Tag>
    </div>
  );
};
